import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { ICardToListOperation, IOperationData, ISelectCardOperation, ITextinputOperation, ITimeSlotOperation, IInfoPageOperation, OperationType, IlistInputOperation, IListTextInputOperation } from "../../constants/types";
import CardToListOperation from "./cardToListOperation/CardToListOperation";
import SelectCardOperation from "./selectCardOperation/SelectCardOperation";
import TextInputOperation from "./textInputOperation/TextInputOperation";
import ListTextInputOperation from "./listTextInputOperation/ListTextInputOperation";
import TimeSlotOperation from "./timeSlotOperation/TimeSlotOperation";
import ListInputOperation from "./listInputOperation/ListInputOperation";
import InfoPageOperation from "./infoPageOperation/InfoPageOperation";

interface Props extends WithTranslation {
    operation: OperationType,
    data: IOperationData,
    onChange: (changes: IOperationData) => void
};

class Operation extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    renderOperation(operation: OperationType, data: IOperationData, onChange: (changes: any) => void) {
        switch (operation.type) {
            case "INFO-PAGE":
                return <InfoPageOperation operation={operation as IInfoPageOperation} data={data} onChange={onChange} />;
            case "SELECT-CARD":
                return <SelectCardOperation operation={operation as ISelectCardOperation} data={data} onChange={onChange} />;
            case "TEXT-INPUT":
                return <TextInputOperation operation={operation as ITextinputOperation} data={data} onChange={onChange} />;
            case "CARD-TO-LIST":
                return <CardToListOperation operation={operation as ICardToListOperation} data={data} onChange={onChange} />;
            case "TIME-SLOT":
                return <TimeSlotOperation operation={operation as ITimeSlotOperation} data={data} onChange={onChange} />;
            case "LIST-INPUT":
                return <ListInputOperation operation={operation as IlistInputOperation} data={data} onChange={onChange} />;
            case "LIST-TEXT-INPUT":
                return <ListTextInputOperation operation={operation as IListTextInputOperation} data={data} onChange={onChange} />;
            default:
                return null;
        }
    }

    render() {
        const { operation, data, onChange } = this.props;

        return <div className="render-operation" >
            {this.renderOperation(operation, data, onChange)}
        </div>;
    }
};

export default withTranslation()(Operation);